module.exports = __webpack_public_path__ + "img/ring_g_skip_null_null@2x.4976f92f.png";